import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCash = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4V6h16z" />
  </SvgIcon>
);

export default IconCash;



// WEBPACK FOOTER //
// ./src/components/icons/IconCash.js